import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AppWindow } from '../AppWindow';

export interface ITrackingInformation {
  utm_campaign: string;
  utm_content: string;
  utm_source: string;
  utm_medium: string;

  [key: string]: string;
}

@Injectable({
  providedIn: 'root',
})
export class UserTrackerService {
  private static readonly trackingCodes: string[] = ['utm_campaign', 'utm_content', 'utm_source', 'utm_medium'];
  private readonly _storage: Storage;

  constructor(
    @Inject('window') _window: AppWindow,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._storage = _window.sessionStorage;
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      const trackingInformation: Record<string, string> = {};
      Object.entries(params)
        .filter((entry: [string, string]) => UserTrackerService.trackingCodes.includes(entry[0].toLowerCase()))
        .forEach((entry: [string, string]) => {
          trackingInformation[entry[0].toLowerCase()] = entry[1];
        });
      if (Object.keys(trackingInformation).length > 0) {
        this._storage.setItem('utm_info', JSON.stringify(trackingInformation));
      }
    });
  }

  public getTrackingInformation(): ITrackingInformation | null {
    const info = this._storage.getItem('utm_info');
    if (!info) {
      return null;
    }
    return JSON.parse(info);
  }
}
